import React, { useCallback, useEffect, useState } from 'react';
import { Card, Table, Tag, Space, Button, Segmented, Select, Tooltip, Typography, message } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { useTranslation } from '../../../shared/i18n';
import apiClient from '../../../shared/services/apiClient';

const { Text } = Typography;
const NOTICE_COLOR = { sent: 'success', pending: 'processing', skipped: 'default', none: 'default' };

/** 一直失败 / 卡住的资源(FailureWatch 登记;新出现的已推运维群 + 客户) */
const Failures = () => {
    const { t } = useTranslation();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState('1');
    const [kind, setKind] = useState('');
    const [page, setPage] = useState(1);

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const r = (await apiClient.get('/api/admin/system/failures', { params: { open, kind, page } })).data;
            if (r.success) setData(r.data); else message.error(r.error || t('Failed to load'));
        } catch (e) {
            message.error(e.response?.data?.error || e.message);
        }
        setLoading(false);
    }, [open, kind, page, t]);
    useEffect(() => { load(); }, [load]);

    const noticeText = (v) => ({ sent: t('Customer notified'), pending: '-', skipped: t('Skipped'), none: '-' }[v] || v);
    const columns = [
        { title: t('Type'), dataIndex: 'kind_name', width: 120 },
        {
            title: t('Resource'), dataIndex: 'label',
            render: (v, r) => <Space size={4}><Text code>#{r.ref_id}</Text>{v}</Space>,
        },
        {
            title: t('Status'), dataIndex: 'state', width: 90,
            render: (v, r) => (r.resolved_at ? <Tag>{t('Resolved')}</Tag>
                : <Tag color={v === 'failed' ? 'error' : 'warning'}>{v === 'failed' ? t('Failed') : t('Stuck')}</Tag>),
        },
        { title: t('User'), dataIndex: 'username', width: 160, render: (v, r) => <Tooltip title={r.email}>{v || '-'} <Text type="secondary">#{r.user_id}</Text></Tooltip> },
        { title: t('Reason'), dataIndex: 'reason', render: (v) => <Text style={{ fontSize: 12 }}>{v}</Text> },
        { title: t('First seen'), dataIndex: 'first_seen_at', width: 160 },
        { title: t('Last seen'), dataIndex: 'last_seen_at', width: 160 },
        { title: t('Customer notified'), dataIndex: 'user_notice', width: 110, render: (v) => <Tag color={NOTICE_COLOR[v]}>{noticeText(v)}</Tag> },
    ];

    return (
        <Card
            title={t('Failed / stuck')}
            extra={(
                <Space wrap>
                    <Segmented value={open} onChange={(v) => { setOpen(v); setPage(1); }} options={[{ label: t('Unresolved'), value: '1' }, { label: t('All'), value: '0' }]} />
                    <Select
                        style={{ width: 150 }} value={kind} onChange={(v) => { setKind(v); setPage(1); }}
                        options={[{ label: t('All'), value: '' }, ...Object.entries(data?.kinds || {}).map(([k, v]) => ({ label: v, value: k }))]}
                    />
                    <Button icon={<ReloadOutlined />} onClick={load} loading={loading} />
                </Space>
            )}
        >
            <Table
                rowKey="id" size="small" loading={loading} columns={columns} dataSource={data?.items || []} scroll={{ x: 1100 }}
                pagination={{ current: page, pageSize: data?.per_page || 50, total: data?.total || 0, onChange: setPage, showSizeChanger: false }}
            />
        </Card>
    );
};

export default Failures;
